/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Card_VisitorsInputs */

const en_admin_funnel_card_visitors = /** @type {(inputs: Admin_Funnel_Card_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitors today`)
};

/**
* | output |
* | --- |
* | "Visitors today" |
*
* @param {Admin_Funnel_Card_VisitorsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_visitors = /** @type {((inputs?: Admin_Funnel_Card_VisitorsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_VisitorsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_visitors(inputs)
});
export { admin_funnel_card_visitors as "admin.funnel.card.visitors" }